import React, { FC } from 'react';
import { Trans } from 'react-i18next';

import { BREAK_POINTS } from 'src/front/constant';
import styled from 'styled-components';

interface CampaignBannerProps {
  item: CampaignBannerItem;
}

export interface CampaignBannerItem {
  background: string;
  image: string;
  title: string;
  description: string;
  id: string;
  buttonText?: string;
  link?: string;
}

const CampaignBannerPage = styled.div`
  height: 379px;
`;

const CampaignBannerItemContainer = styled.div<{ background: string }>`
  height: inherit;
  background-image: url(${({ background }) => background});
  background-size: cover;

  padding: 0 50px;

  & > div {
    float: left;
  }

  & > * {
    color: white;
  }

  @media screen and (max-width: ${BREAK_POINTS.MAX.PHONE}) {
    display: flex;
    width: 100%;
    padding: 0;

    & > div {
      height: auto;
      padding-left: 15px;
    }

    & p {
      font-size: 18px;
    }

    & h1 {
      margin-top: 40px;

      font-size: 20px;
    }
  }
`;

const CampaignBannerItemTextContainer = styled.div`
  width: 70%;

  @media screen and (max-width: ${BREAK_POINTS.MAX.LARGE_1X}) and (min-width: ${BREAK_POINTS.MIN
      .PHONE}) {
    width: 50%;
  }
`;

const CampaignBannerItemImageContainer = styled.div`
  display: flex;
  width: 30%;
  height: inherit;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: ${BREAK_POINTS.MAX.LARGE_1X}) and (min-width: ${BREAK_POINTS.MIN
      .PHONE}) {
    float: right !important;
  }

  @media screen and (max-width: ${BREAK_POINTS.MAX.PHONE}) {
    width: 250px;
    height: auto;
  }
`;

const CampaignBannerItemDescription = styled.p`
  font-size: 20px;
  white-space: pre-line;
`;

const CampaignLink = styled.a`
  display: block;
  margin: 80px 0;

  color: white;

  @media screen and (max-width: ${BREAK_POINTS.MAX.LARGE_1X}) and (min-width: ${BREAK_POINTS.MIN
      .PHONE_MINIMUM}) {
    margin: 30px 0 20px;
  }
`;

const CampaignBanner: FC<CampaignBannerProps> = ({ item }) => {
  const isCampaignLinkAvailable = item.buttonText && item.link;

  return (
    <CampaignBannerPage key={item.id}>
      <CampaignBannerItemContainer background={item.background}>
        <CampaignBannerItemTextContainer>
          <h1>
            <Trans i18nKey={item.title} />
          </h1>
          <CampaignBannerItemDescription>
            <Trans i18nKey={item.description} />
          </CampaignBannerItemDescription>
          {isCampaignLinkAvailable ? (
            <CampaignLink href={item.link} target="_blank">
              <Trans i18nKey={item.buttonText} />
            </CampaignLink>
          ) : null}
        </CampaignBannerItemTextContainer>
        <CampaignBannerItemImageContainer>
          <img alt={item.id} src={item.image} />
        </CampaignBannerItemImageContainer>
      </CampaignBannerItemContainer>
    </CampaignBannerPage>
  );
};

export default CampaignBanner;
